var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.125C1 9.62228 1.19754 10.0992 1.54917 10.4508C1.90081 10.8025 2.37772 11 2.875 11C3.37228 11 3.84919 10.8025 4.20083 10.4508C4.55246 10.0992 4.75 9.62228 4.75 9.125C4.75 8.62772 4.55246 8.15081 4.20083 7.79917C3.84919 7.44754 3.37228 7.25 2.875 7.25C2.37772 7.25 1.90081 7.44754 1.54917 7.79917C1.19754 8.15081 1 8.62772 1 9.125Z",
    stroke: "#8698A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.125C7.25 9.62228 7.44754 10.0992 7.79917 10.4508C8.15081 10.8025 8.62772 11 9.125 11C9.62228 11 10.0992 10.8025 10.4508 10.4508C10.8025 10.0992 11 9.62228 11 9.125C11 8.62772 10.8025 8.15081 10.4508 7.79917C10.0992 7.44754 9.62228 7.25 9.125 7.25C8.62772 7.25 8.15081 7.44754 7.79917 7.79917C7.44754 8.15081 7.25 8.62772 7.25 9.125Z",
    stroke: "#8698A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 9.125V1H11V9.125",
    stroke: "#8698A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 3.5H11",
    stroke: "#8698A9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/MusicIcon.a610f85378185fae7c6f99ec002604f6.svg";
export { ForwardRef as ReactComponent };